import React from 'react'
import Image from 'next/image'
import styles from './404.module.scss'
import { DoesNotExistProps } from '~types'
import { Button } from '~elements'
import { NEXT_IMAGE_QUALITY } from '~constants'
import { getGtmLinkPosition } from '~analyticsUtils'
import { useWindowSize } from 'utils/hooks'

const DoesNotExist = ({ backgroundImage, buttonGroup }: DoesNotExistProps) => {
  const linkModule = 'does_not_exist'
  const { isBreakpoint: isBelowSm } = useWindowSize('sm', '<')

  return (
    <div className={styles['not-found']}>
      <div className={styles['overlay']}></div>
      <div className={styles['does-not-exist-inner-container']}>404</div>

      <div className={styles['does-not-exist-inner-content-container']}>
        <div className={styles['heading-text']}>
          <div className={styles['text-main']}>Page Not Found</div>
          <div className={styles['text-lead']}>
            <span>Oops. We couldn’t find that page.</span>
            <span>Maybe you can find what you need here?</span>
          </div>
        </div>
        <div className={styles['back-home-btn-container']}>
          <Button
            isFullWidth={isBelowSm}
            title='Back Home'
            fill='solid'
            color='light'
            url='/'
            justify='center'
            analytics={{ linkModule: linkModule }}
          />
        </div>
        <div className={styles['text-bottom']}>
          <span>or go to</span>
        </div>
        {buttonGroup && buttonGroup.length > 0 && (
          <div className={styles['bottom-btn-container']}>
            {buttonGroup.map((button, index) => {
              return (
                <Button
                  key={`${button.title}_${index}`}
                  {...button}
                  isFullWidth={true}
                  analytics={{
                    linkModule: linkModule,
                    linkPosition: getGtmLinkPosition(buttonGroup, index)
                  }}
                />
              )
            })}
          </div>
        )}
      </div>
      {backgroundImage?.url && (
        <Image
          src={backgroundImage?.url}
          alt={backgroundImage?.altText || ''}
          fill
          style={{ objectFit: 'cover' }}
          quality={NEXT_IMAGE_QUALITY}
        />
      )}
    </div>
  )
}

export default DoesNotExist
